/* eslint-disable no-extra-boolean-cast */
/* eslint-disable no-shadow */
import React from 'react';
import { connect, useSelector } from 'react-redux';
import { orderBy } from 'lodash';

import FacilityExclusion from './FacilityExclusion';

import { removeCourtExclusionList, addCourtExclusionList } from '../../../actions/draw-edit-actions';

import styles from '../drawEdit.scss';

const _ = { orderBy };

const LocationsSubHeaderV2 = (props) => {
    const { facilities, selectedFacility, updateSelectedFacility } = props;
    const drawEdit = useSelector(({ drawEdit }) => drawEdit);
    const { locations } = drawEdit;

    const disablePrevButton = () => (selectedFacility === 0 || locations.updating || locations.loading);
    const disableNextButton = () => ((selectedFacility === facilities.length - 3 || facilities.length < 4) || locations.updating || locations.loading);
    const sortedFacilities = _.orderBy(facilities || [], [f => f.name?.toLowerCase()]);

    return (
        <div className={`${styles.section} sub-header`}>
            <div className="container">
                {sortedFacilities.length ? (
                    <div className="row">
                        <div className="col-md-4 draws-round d-none d-lg-flex lh36">
                            <div
                                className={`click-area click-area-36 float-left ${disablePrevButton() ? 'disabled' : ''}`}
                                onClick={() => {
                                    if (!disablePrevButton()) {
                                        updateSelectedFacility('down');
                                    }
                                }}
                                data-testid="locations.sub-header.prev-btn"
                            >
                                <i className={`uts uts-prev`} />
                            </div>
                            <FacilityExclusion
                                {...props}
                                facility={sortedFacilities[selectedFacility]}
                            />
                        </div>
                        <div className="col-md-4 draws-round d-none d-lg-block lh36">
                            <FacilityExclusion
                                {...props}
                                facility={sortedFacilities[selectedFacility + 1]}
                            />
                        </div>
                        <div className="col-md-4 draws-round d-none d-lg-flex lh36">
                            <FacilityExclusion
                                {...props}
                                facility={sortedFacilities[selectedFacility + 2]}
                            />
                            <div
                                className={`click-area click-area-36 float-right ${disableNextButton() ? 'disabled' : ''}`}
                                onClick={() => {
                                    if (!disableNextButton()) {
                                        updateSelectedFacility('up');
                                    }
                                }}
                                data-testid="locations.sub-header.next-btn"
                            >
                                <i className={`uts uts-next`} />
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className="row">
                        <div className="col-12" />
                    </div>
                )}
            </div>
        </div>
    );
};

function mapDispatchToProps(dispatch) {
    return {
        removeCourtExclusionList: (exclusionList) => dispatch(removeCourtExclusionList(exclusionList)),
        addCourtExclusionList: (exlusionList) => dispatch(addCourtExclusionList(exlusionList)),
    };
}

export default connect(null, mapDispatchToProps)(LocationsSubHeaderV2);
